/* eslint-disable import/no-import-module-exports */

// Import Dependencies
import Blazy from 'blazy';
import Expandable from './ramen-imports/expandable';
import FormToggle from './ramen-imports/formtoggle';
import Pagination from './ramen-imports/pagination';
import RangeSlider from './ramen-imports/rangeslider';
import Validator from './ramen-imports/validator';
import ViewportHeight from './components/ViewportHeight';

const appModules = (async () => {
  // eslint-disable-next-line no-unused-vars
  const vh = new ViewportHeight();

  // Initialise Blazy
  const lazyImageInstances = new Blazy({
    selector: '.js-lazyload',
    successClass: 'is-lazyloaded',
    errorClass: 'has-load-error',
    breakpoints: [
      {
        width: 900, // max-width
        src: 'data-src-small',
      },
    ],
    offset: 600,
  });

  // Fire up lazyload for images
  lazyImageInstances.revalidate();

  // CardSlider
  if (document.querySelector('.js-card-slider-container')) {
    const { default: CardSlider } = await import('./components/CardSlider');
    CardSlider({
      selector: '.js-card-slider-container',
      slidesPerView: 'auto',
      spaceBetween: 0,
      grabCursor: true,
      pagination: {
        el: '.js-card-slider-progressbar',
        type: 'progressbar',
      },
      a11y: true,
      revalidateLazyImages: lazyImageInstances.revalidate,
    });
  }

  if (document.querySelector('.js-card-slider-container-related')) {
    const { default: CardSlider } = await import('./components/CardSlider');
    CardSlider({
      selector: '.js-card-slider-container-related',
      slidesPerView: 'auto',
      spaceBetween: 0,
      grabCursor: true,
      a11y: true,
      revalidateLazyImages: lazyImageInstances.revalidate,
      noLightbox: true,
    });
  }

  if (document.querySelector('.js-hero-carousel-container')) {
    const { default: CardSlider } = await import('./components/CardSlider');
    CardSlider({
      selector: '.js-hero-carousel-container',
      slidesPerView: '1',
      spaceBetween: 0,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.js-hero-carousel-progressbar',
        type: 'bullets',
      },
      autoplay: {
        delay: 8000,
      },
      a11y: true,
      revalidateLazyImages: lazyImageInstances.revalidate,
    });
  }

  // Cookies
  if (document.querySelector('.js-cookies')) {
    const { default: Cookies } = await import('./components/Cookies');
    Cookies({
      selector: '.js-cookies',
      cta: '.js-cookies-cta',
    });
  }

  // Countdown
  if (document.querySelector('.js-countdown')) {
    const { default: Countdown } = await import('./components/Countdown');
    Countdown({
      selector: '.js-countdown',
    });
  }

  // Datetime
  if (document.querySelector('.js-datetime')) {
    const { default: Datetime } = await import('./components/Datetime');
    Datetime({
      selector: '.js-datetime',
    });
  }

  // DriverCard
  if (document.querySelector('.js-card--driver')) {
    const { default: DriverCard } = await import('./components/DriverCard');
    DriverCard({
      selector: '.js-card--driver',
    });
  }

  // EventSchedule
  if (document.querySelector('.js-schedule-app')) {
    const { default: EventSchedule } = await import('./components/EventSchedule');
    EventSchedule({
      selector: '.js-schedule-app',
    });
  }

  Expandable({
    selector: '.js-expandable',
    button: '.js-expandable-button',
    contentPanel: '.js-expandable-content',
    openClass: 'is-open',
  });

  // FormInputHideLabel
  if (document.querySelector('.js-hide-label')) {
    const { default: FormInputHideLabel } = await import('./components/FormInputHideLabel');
    FormInputHideLabel({
      selector: '.js-hide-label',
    });
  }

  FormToggle({
    selector: '.js-toggle',
  });

  // HeroVimeo
  if (document.querySelector('.js-vimeo-player')) {
    const { default: HeroVimeo } = await import('./components/HeroVimeo');
    HeroVimeo({
      selector: '.js-vimeo-player',
    });
  }

  // LogoList
  if (document.querySelector('.js-logo-listing')) {
    const { default: LogoList } = await import('./components/LogoList/LogoList');
    LogoList({
      selector: '.js-logo-listing',
      forceToAxis: true,
      mousewheel: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      grabCursor: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: '.js-logo-listing-progressbar',
        type: 'progressbar',
      },
      a11y: true,
    });
  }

  // MultiRangeSlider
  if (document.querySelector('.js-multi-range-slider')) {
    const { default: MultiRangeSlider } = await import('./components/MultiRangeSlider/MultiRangeSlider');
    MultiRangeSlider({
      selector: '.js-multi-range-slider',
      inverseLeft: '.js-inverse-left',
      inverseRight: '.js-inverse-right',
      range: '.js-range',
      inputLeft: '.js-input-left',
      inputRight: '.js-input-right',
      thumbLeft: '.js-thumb-left',
      thumbRight: '.js-thumb-right',
      valueLeft: '.js-value-left',
      valueRight: '.js-value-right',
    });
  }

  // Navigation
  if (document.querySelector('.js-nav')) {
    const { default: Navigation } = await import('./components/Navigation');
    Navigation({
      selector: '.js-nav',
      navItems: '.js-nav-item',
      navBtns: '.js-subnav-toggle',
      searchWrapper: '.js-search',
      searchBtns: '.js-search-toggle',
      searchBackBtn: '.js-nav-search-back',
      subnavWrapper: '.js-subnav-wrapper',
      subnavItems: '.js-subnav-item',
      subnavContentWrapper: '.js-subnav-content-wrapper',
      subnavItemsContentEles: '.js-subnav-item-content',
      subnavBackBtns: '.js-nav-subnav-btn',
    });
  }

  Pagination({
    selector: '.js-pagination',
    paginationItems: '.js-pagination-link',
  });

  RangeSlider({
    selector: '.js-range-slider',
  });

  // Search
  if (document.querySelector('.js-search')) {
    const { default: Search } = await import('./components/Search');
    Search({
      selector: '.js-search',
      form: '.js-search-form',
      trigger: '.js-search-trigger',
      input: '.js-search-input',
      deleteBtn: '.js-search-delete',
    });
  }

  // SideImages
  if (document.querySelector('.js-side-images')) {
    const { default: SideImages } = await import('./components/SideImages');
    SideImages({
      selector: '.js-side-images',
      images: '.js-side-images-image',
      sideContent: '.js-side-content',
    });
  }

  // SingleImageLightbox
  if (document.querySelector('.js-glightbox')) {
    const { default: SingleImageLightbox } = await import('./components/SingleImageLightbox/SingleImageLightbox');
    SingleImageLightbox({
      selector: '.js-glightbox',
    });
  }

  // SubscriptionForm
  if (document.querySelector('.js-marketo-form')) {
    const { default: SubscriptionForm } = await import('./components/SubscriptionForm');
    SubscriptionForm({
      selector: '.js-marketo-form',
      subscriptionConfirm: 'aliId',
      subscriptionConfirmMessage: '.js-subscription-confirm-message',
    });
  }

  // TicketOptions
  if (document.querySelector('.js-ticket-options')) {
    const { default: TicketOptions } = await import('./components/TicketOptions');
    TicketOptions({
      selector: '.js-ticket-options',
      slider: '.js-ticket-options-selector',
      options: '.js-ticket-option',
      optionsContent: '.js-ticket-content',
      swiperSettings: {
        breakpoints: {
          600: {
            slidesPerView: 3,
          },
          900: {
            slidesPerView: 6,
            preventInteractionOnTransition: true,
          },
        },
        direction: 'horizontal',
        preventClicks: false,
        preventClicksPropagation: false,
        resistanceRatio: 0,
        slidesPerView: 2,
        threshold: 10,
      },
    });
  }

  // TicketSelector
  if (document.querySelector('.js-ticket-selector')) {
    const { default: TicketSelector } = await import('./components/TicketSelector');
    TicketSelector({
      selector: '.js-ticket-selector',
      filters: '.js-filters',
      options: '.js-options input',
      passes: '.js-passes',
      optionsMobile: '.js-options-mobile input',
      showFilters: '.js-show-filters',
      showFiltersWrapper: '.js-show-filters-wrapper',
      closeFilters: '.js-close-filters',
      resetFilters: '.js-reset-filters',
      breakpoint: '900px',
    });
  }

  // TicketSelectorV2
  if (document.querySelector('.js-ticket-selector-app')) {
    const { default: TicketSelectorV2 } = await import('./components/TicketSelectorV2');
    TicketSelectorV2({
      selector: '.js-ticket-selector-app',
    });
  }

  // Toggle
  if (document.querySelector('.js-toggle')) {
    const { default: Toggle } = await import('./components/Toggle');
    Toggle({
      selector: '.js-toggle',
    });
  }

  // TrackMap
  if (document.querySelector('.js-track-map')) {
    const { default: TrackMap } = await import('./components/TrackMap/TrackMap');
    TrackMap({
      selector: '.js-track-map',
      ticket: '.js-track-map-ticket',
      popup: '.js-track-map-popup',
      track: '.js-track-map-track',
    });
  }

  // TwoImages
  if (document.querySelector('.js-two-images')) {
    const { default: TwoImages } = await import('./components/TwoImages');
    TwoImages({
      selector: '.js-two-images',
      imageContainer: '.js-two-images-container',
      firstImage: '.js-first-image',
      firstImageContainer: '.js-first-image-container',
      breakpoint: '900px',
    });
  }

  Validator({
    selector: '.js-validate',
  });

  // Video
  if (document.querySelector('.js-video')) {
    const { default: Video } = await import('./components/Video');
    Video({
      selector: '.js-video',
      button: '.js-video-button',
    });
  }

  // VideoModal
  if (document.querySelector('.js-image-modal')) {
    const { default: VideoModal } = await import('./components/VideoModal');
    VideoModal({
      selector: '.js-image-modal',
      modalButton: '.js-video-modal-button',
      closeButton: '.js-modal-close',
      modalInner: '.js-modal-inner',
      loader: '.js-modal-loader',
      modalOpen: 'is-visible',
      showOverlay: 'has-overlay',
      modalIdAttr: 'data-modal-id',
      videoIdAttr: 'data-video-id',
      videoTypeAttr: 'data-video-type',
      videoPosterAttr: 'data-video-poster',
    });
  }

  if (document.querySelector('.mktoForm')) {
    const { default: marketoFormsUtils } = await import('./components/marketoFormsUtils');
    marketoFormsUtils();
  }
})();

// Opt-in to Webpack hot module replacement
if (module.hot) module.hot.accept();

export default appModules;
